import Helper from './Helper';

class Video {
  constructor() {
    const thumbnail = Array.prototype.slice.call(document.querySelectorAll('.ns-video__thumbnail'));
    thumbnail.forEach(image =>{
      image.addEventListener('click', () => {
        const video = image.parentElement;
        // const button = video.querySelector('button');
        const iframe = video.querySelector('iframe');
        if ( typeof iframe !== undefined && iframe !== null ) {
          iframe.src = iframe.src + '?autoplay=1';
        } else {
          const localVideo = video.querySelector('video');
          localVideo.play();
        }
        
        // button.classList.add('fade-out');
        image.classList.add('fade-out');
        // button.style.display = 'none';
        image.style.display = 'none';
      });
    });
  }
} export default Video;
